import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AgGridAngular } from 'ag-grid-angular';
import { tap } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[y42AgGridIntercomTargetDirective]',
})
export class AgGridIntercomTargetDirective implements OnInit {
  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly agGrid: AgGridAngular,
  ) {}

  @Input() y42AgGridIntercomTargetDirective = '';

  ngOnInit() {
    this.agGrid.gridReady
      .pipe(
        tap(() => {
          const headerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.ag-header-viewport');
          this.renderer.setAttribute(headerElement, 'data-intercom-target', this.y42AgGridIntercomTargetDirective);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
